import React from 'react';

import { SVGComponentProps } from './svg.types';

const CustomMultiSelectSvg = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <path
          d="M13.491 1.66699H6.50768C3.47435 1.66699 1.66602 3.47533 1.66602 6.50866V13.492C1.66602 16.5253 3.47435 18.3337 6.50768 18.3337H13.491C16.5244 18.3337 18.3327 16.5253 18.3327 13.492V6.50866C18.3327 3.47533 16.5244 1.66699 13.491 1.66699ZM8.30768 12.417L6.43268 14.292C6.30768 14.417 6.14935 14.4753 5.99102 14.4753C5.83268 14.4753 5.66602 14.417 5.54935 14.292L4.92435 13.667C4.67435 13.4253 4.67435 13.0253 4.92435 12.7837C5.16602 12.542 5.55768 12.542 5.80768 12.7837L5.99102 12.967L7.42435 11.5337C7.66602 11.292 8.05768 11.292 8.30768 11.5337C8.54935 11.7753 8.54935 12.1753 8.30768 12.417ZM8.30768 6.58366L6.43268 8.45866C6.30768 8.58366 6.14935 8.64199 5.99102 8.64199C5.83268 8.64199 5.66602 8.58366 5.54935 8.45866L4.92435 7.83366C4.67435 7.59199 4.67435 7.19199 4.92435 6.95033C5.16602 6.70866 5.55768 6.70866 5.80768 6.95033L5.99102 7.13366L7.42435 5.70033C7.66602 5.45866 8.05768 5.45866 8.30768 5.70033C8.54935 5.94199 8.54935 6.34199 8.30768 6.58366ZM14.6327 13.8503H10.2577C9.91602 13.8503 9.63268 13.567 9.63268 13.2253C9.63268 12.8837 9.91602 12.6003 10.2577 12.6003H14.6327C14.9827 12.6003 15.2577 12.8837 15.2577 13.2253C15.2577 13.567 14.9827 13.8503 14.6327 13.8503ZM14.6327 8.01699H10.2577C9.91602 8.01699 9.63268 7.73366 9.63268 7.39199C9.63268 7.05033 9.91602 6.76699 10.2577 6.76699H14.6327C14.9827 6.76699 15.2577 7.05033 15.2577 7.39199C15.2577 7.73366 14.9827 8.01699 14.6327 8.01699Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default CustomMultiSelectSvg;
